import { erpAxios } from '.';

const setOdobrioKOdbor1 = async (data) => {
  const res = await erpAxios.post(`/odborGrupe/setOdobrioKOdbor1`, data);
  return res;
};

export default setOdobrioKOdbor1;
